import { render, staticRenderFns } from "./PerSubjectTable.vue?vue&type=template&id=3ff408fd&"
import script from "./PerSubjectTable.vue?vue&type=script&lang=ts&"
export * from "./PerSubjectTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports